let scrollTop = 0;

const lockScroll = () => {
  scrollTop = document.body.getBoundingClientRect().top;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.right = '0';
  document.body.style.top = `${scrollTop}px`;
};

const unlockScroll = () => {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.right = '';

  const html = document.querySelector('html');

  if (html) {
    html.scrollTop = scrollTop * -1;
  }
};

export const useScrollLock = () => {
  return {
    lockScroll,
    unlockScroll,
  };
};
